/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_UsersInputs */

const en_total_users = /** @type {(inputs: Total_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Users`)
};

const de_total_users = /** @type {(inputs: Total_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer insgesamt`)
};

/**
* | output |
* | --- |
* | "Total Users" |
*
* @param {Total_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const total_users = /** @type {((inputs?: Total_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_total_users(inputs)
	return en_total_users(inputs)
});